import React from 'react';
import { modelClass } from '/imports/api/cards';
import { ModelFormPage } from '/imports/ui/ModelFormPage';
import { NumberInput } from '/imports/ui/NumberInput';
import { Checkbox } from '/imports/ui/Checkbox';
import { FilesInput } from '/imports/ui/FilesInput';

export const CardPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [
      [{ field: 'name', label: 'Name' }],
      [{ field: 'setName', label: 'Set' }],
      [{ field: 'rarity', label: 'Rarity' }],
      [{ field: 'isfoil', label: 'Foil' }],
      [{ field: 'manBuyPrice', label: 'Manual Buy Price' }],
      [{ field: 'manSellPrice', label: 'Manual Sell Price' }],
      [
        {
          field: 'gbBuyMargin', label: 'GB Buy Margin (%)', optional: true,
          input: { type: NumberInput },
          tip: 'manBuyPrice = gbBuyPrice × (1 + margin/100). Overrides the set margin and the default pricing. Leave blank to fall back.',
        },
        {
          field: 'gbSellMargin', label: 'GB Sell Margin (%)', optional: true,
          input: { type: NumberInput },
          tip: 'manSellPrice = gbSellPrice × (1 + margin/100). Overrides the set margin and the default pricing. Leave blank to fall back.',
        },
      ],
      [
        {
          field: 'fixedPrice', label: 'Fixed Price',
          input: { type: Checkbox },
          tip: 'Protect this card\'s prices from the goatbots scraper. Goatbots\' own prices keep updating (so you can still see where the market is), but manBuyPrice, manSellPrice and cashBuyPrice are left exactly as you set them.',
        },
      ],
      [
        {
          field: 'images', label: 'Images', optional: true,
          input: { type: FilesInput, props: { accept: 'image/*' } },
          tip: 'Card/product images shown on the public site (first image is the primary). Normally populated by the gatherer / booster-image scrapers; upload manually for products with no scrapeable image.',
        },
      ],
    ]}
  />
);
